import React from 'react';
import {getIcon, isLink, LinkComponent} from '../Helpers';
import {KEY_NORMAL} from "../../../Constants/Constants";

const KeyValueComponent = ({data_key, data_value, styles, icon}) => {
	return (
		<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', paddingBottom: "0.25em", ...(styles.contactsKeyValueContainer || {})}}>
			<div style={{fontWeight: 500, marginRight: "0.5rem"}}>{data_key}:</div>
			{
				isLink(data_value) ? (
					<LinkComponent 
						print={true} 
						link={data_value} 
						anchor={data_value} 
						icon={icon} 
						isIconBefore={true} 
						styles={styles}
					/>
				) : <div>{data_value}</div>
			}
		</div>
	);
};

const KeyValueGroupComponent = ({data, styles}) => {
	return (
		<div style={{paddingBottom: "0"}}>
			{
				data.map(
					(item, index) =>
						<KeyValueComponent
							data_key={item.key}
							data_value={item.value}
							key={index}
							styles={styles}
						/>
				)
			}
		</div>
	);
};
// const SocialComponent = (props) => (
//
// );

const Contacts = ({data, styles, social, printSocialAnchors, socialLinkSize}) => {
	let social_keys = social ? Object.keys(social) : null;
	socialLinkSize = socialLinkSize ? socialLinkSize : KEY_NORMAL;

	return (
		<div className="d-flex flex-sm-column contact-lists-container">
			<div style={{marginBottom: "1rem"}}>
				{
					data.map((column, index) => <KeyValueGroupComponent data={column} key={index} styles={styles}/>)
				}
			</div>
			<div>
				{
					social_keys ? (
						<div className="d-flex flex-column justify-content-end align-items-end" style={styles.socialLinksContainer}>
							{
								social_keys.map((prop) => {
									let anchor = social[prop];
									anchor = anchor.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "");//.split('/')[0];
									// //console.log(anchor, printSocialAnchors);
									return (
										<LinkComponent
											key={prop}
											// icon={getIcon(prop, socialLinkSize)}
											anchor={anchor}
											printAnchor={printSocialAnchors}
											styles={styles.social_links}
											print 
											link={social[prop]}
											isIconBefore
										/>
									)
								})
							}
						</div>
					) : null
				}
			</div>
		</div>
	)
};

export default Contacts;